import { useMutation, useQueryClient } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"

export type CreateUserData = {
  firstName: string
  surname: string
  email: string
  password?: string
  role: string
  team?: string
  sub_teams?: string[]
  dsp_id?: string
  driver_manager_team_id?: string
  // HIVED-person fields
  driver_manager_team?: string
  functionAreas?: string[]
  location?: string[]
}

export const useCreateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userData: CreateUserData) => {
      const { data, error } = await supabase.functions.invoke("create-user", {
        body: userData,
      })

      if (error) {
        throw new Error(error.message)
      }

      return data
    },
    onSuccess: () => {
      // Invalidate and refetch the users query to update the UI
      queryClient.invalidateQueries({ queryKey: ["users"] })
    },
  })
}
